module.exports = __webpack_public_path__ + "static/media/paymentWidgets.cd6efd9d.svg";